export default "__VITE_ASSET__CK_0Ok_E__"